import styled from 'styled-components';

export const Content = styled.div``;

export const Item = styled.div`
  margin-bottom: 20px;
  &:last-child{
    margin-bottom: 0;
  }
`;

export const ItemTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 13px;
  height: 28px;
  color: #fff;
  margin-bottom: 10px;
  img {
    margin-right: 15px;
  }
`;

export const ItemContent = styled.div`
  color: #8d8d8d;
  font-size: 13px;
`;
